var map = {
	"./bentley.png": 56200,
	"./dnevnik.png": 48631,
	"./gagagames.png": 87199,
	"./italy_co.png": 35044,
	"./lenfilm.png": 32951,
	"./museum.png": 21708,
	"./open_city.png": 8187,
	"./petersburg_diary.png": 73150,
	"./planetariy.png": 9635,
	"./pravitelstvo.png": 57087,
	"./rosatom.png": 58246,
	"./rumuseum.png": 28630,
	"./rzd.png": 76132,
	"./sobaka.png": 51088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34768;